const messages = {
  outsourcing: {
    calendar: {
      display_days_before: '30',
      display_days_after: '14'
    },
    evaluator: 'Gerente',
    start_visit: "Iniciar Visita",
    stop_visit: "Finalizar Visita",
    person: "Supervisor",
    label: {
      instructions: "Instruções"
    }
  },
  cooperative: {
    calendar: {
      display_days_before: '3',
      display_days_after: '14'
    },
    start_visit: "Entrada",
    stop_visit: "Saída",
    person: "Supervisor",
    label: {
      instructions: 'Quadro do Paciente'
    }
  },
  franchising: {
    calendar: {
      display_days_before: '30',
      display_days_after: '14'
    },
    start_visit: "Entrada",
    stop_visit: "Saída",
    evaluator: 'Franqueado',
    person: "Supervisor",
    label: {
      instructions: 'Observações'
    }
  },
  hospital: {
    calendar: {
      display_days_before: '30',
      display_days_after: '14'
    },
    start_visit: "Entrada",
    stop_visit: "Saída",
    evaluator: 'Paciente',
    person: "Supervisor",
    label: {
      instructions: 'Observações'
    }
  },
  spoc: {
    calendar: {
      display_days_before: '30',
      display_days_after: '14'
    },
    start_visit: "Entrada",
    stop_visit: "Saída",
    customer: 'Paciente',
    person: "Supervisor",
    label: {
      instructions: 'Observações'
    }
  }

}

export default messages


// WEBPACK FOOTER //
// ./src/locale/pt_br.js